<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>采购管理</el-breadcrumb-item>
                <el-breadcrumb-item>采购订单 - (供应链接收到采购需求，将采购需求下单至工厂。经工厂下单成功后审核转至待回货单)</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-form label-width="90px" class="search-form">
            <el-row>
                <el-form-item label="关键词">
                    <el-col>
                        <el-input v-model="query.keyword" prefix-icon="Search" placeholder="单号/供应商/采购员" @keyup.enter="fetchs()"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select v-model="status" clearable placeholder="请选择" @change="fetchs()"
                        style="min-width: 140px;">
                        <el-option label="草稿" value="0"></el-option>
                        <el-option label="待审核" value="1"></el-option>
                        <el-option label="已审核" value="2"></el-option>
                        <el-option label="执行中" value="3"></el-option>
                        <el-option label="已完成" value="4"></el-option>
                        <el-option label="已作废" value="-1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="到货状态">
                    <el-select v-model="deliveryStatus" clearable placeholder="请选择" @change="fetchs()"
                        style="min-width: 140px;">
                        <el-option label="未到货" value="0"></el-option>
                        <el-option label="部分到货" value="1"></el-option>
                        <el-option label="全部到货" value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="" label-width="20px">
                    <el-button type="primary" icon="search" @click="fetchs()">搜索</el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-button type="primary" icon="Plus" @click="add">新增</el-button>
            <el-button type="danger" icon="Delete" @click="deleter">删除</el-button>

            <el-dropdown style="margin-left:20px;">
                <el-button plain type="primary">
                    <el-icon style="margin-right:5px;">
                        <Upload />
                    </el-icon>
                    数据操作
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item>关闭订单</el-dropdown-item>

                        <el-dropdown-item divided @click="download()">导出列表</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>

            <el-button type="primary" icon="Finished" @click="auditor()" style="margin-left: 80px;">单据审核</el-button>
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:toolbar="scope">
                <el-button @click="edit(scope.row)" link size="small" type="primary" icon="Edit">[编辑]</el-button>
                <el-button @click="view(scope.row)" link size="small" type="info" icon="View">[查看]</el-button>
            </template>

            <template v-slot:status="scope">
                <el-tag :type="statusColor(scope.row.status)">
                    {{ statusText(scope.row.status) }}
                </el-tag>
            </template>

            <template v-slot:deliveryStatus="scope">
                <el-tag :type="deliveryStatusColor(scope.row.deliveryStatus)">
                    {{ deliveryStatusText(scope.row.deliveryStatus) }}
                </el-tag>
            </template>

            <template v-slot:billDate="scope">
                <span>{{ $util.fmtDate(scope.row.billDate, 'yyyy-MM-dd') }}</span>
            </template>

            <template v-slot:deliveryDate="scope">
                <span>{{ scope.row.deliveryDate ? $util.fmtDate(scope.row.deliveryDate, 'yyyy-MM-dd') : '' }}</span>
            </template>
        </basic-table>
    </el-card>
</template>

<script>
import { h } from 'vue';
import StaticDialog from '@/components/static-dialog.vue'
import BasicTable from '@/components/basic-table.vue'

export default {
    name: 'PurchaseOrderBill',
    components: { StaticDialog, BasicTable },
    data() {
        return {
            query: {
                keyword: '',
                columns: [
                    { type: 'index', label: '序号' },
                    { prop: 'billCode', label: '采购订单号', sortable: true, searchable: true, width: '160', showOverflowTooltip: true },
                    { prop: 'externalNo', label: '外部单号', searchable: true, sortable: true, width: '140', showOverflowTooltip: true },
                    { prop: 'billType', label: '单据类型', sortable: true, width: '90', showOverflowTooltip: true },
                    { prop: 'status', label: '状态', type: 'template', width: '80', showOverflowTooltip: true },
                    { prop: 'companyName', label: '公司', searchable: true, sortable: true, width: '180', showOverflowTooltip: true },
                    { prop: 'departmentName', label: '采购部门', searchable: true, sortable: true, width: '100', showOverflowTooltip: true },
                    { prop: 'supplierName', label: '供应商', sortable: true, searchable: true, width: '180', showOverflowTooltip: true },
                    { prop: 'purchaserName', label: '采购员', sortable: true, searchable: true, width: '90', showOverflowTooltip: true },
                    { prop: 'billDate', label: '制单日期', type: 'template', sortable: true, width: '100', showOverflowTooltip: true },
                    { prop: 'deliveryDate', label: '交货日期', type: 'template', sortable: true, width: '100', showOverflowTooltip: true },
                    { prop: 'totalQuantity', label: '总数量', sortable: true, width: '80', showOverflowTooltip: true },
                    { prop: 'totalAmount', label: '总金额', sortable: true, width: '90', showOverflowTooltip: true },
                    { prop: 'totalTaxAmount', label: '含税总额', sortable: true, width: '120', showOverflowTooltip: true },
                    { prop: 'deliveryStatus', label: '到货状态', type: 'template', width: '100', showOverflowTooltip: true },
                    { prop: 'remark', label: '备注', width: '160', showOverflowTooltip: true },
                    { type: 'toolbar', label: '操作', width: '140', fixed: 'right' }
                ],
                filters: [],
                sidx: 'billDate',
                sord: 'desc'
            },
            status: '',
            deliveryStatus: ''
        }
    },
    mounted() {
        this.$kaung.init(this.$options.name)
        this.fetchs()
    },
    methods: {
        statusText(s) {
            switch (s) {
                case 0: return '草稿'
                case 1: return '待审核'
                case 2: return '已审核'
                case 3: return '执行中'
                case 4: return '已完成'
                case -1: return '已作废'
                default: return ''
            }
        },
        statusColor(s) {
            switch (s) {
                case 0: return 'info'
                case 1: return 'warning'
                case 2: return 'success'
                case 3: return 'primary'
                case 4: return 'success'
                case -1: return 'danger'
                default: return 'info'
            }
        },
        deliveryStatusText(s) {
            switch (s) {
                case 0: return '未到货'
                case 1: return '部分到货'
                case 2: return '全部到货'
                default: return ''
            }
        },
        deliveryStatusColor(s) {
            switch (s) {
                case 0: return 'info'
                case 1: return 'warning'
                case 2: return 'success'
                default: return 'info'
            }
        },

        builder() {
            let { data, records, total, ...params } = { ...this.query };

            // 重置并添加筛选条件
            params.filters = [];
            if (this.status) {
                params.filters.push({ name: "status", value: this.status, operate: 0 });
            }
            if (this.deliveryStatus) {
                params.filters.push({ name: "deliveryStatus", value: this.deliveryStatus, operate: 0 });
            }
            return params;
        },
        fetchs() {
            this.$kaung.search(this.builder()).then(res => {
                this.query = { ...res.data }
            })
        },
        download() {
            this.$kaung.export(this.builder()).then(res => {
                this.$notify({ title: '表格数据导出', message: res.content, type: res.type, duration: 10000 })
                window.location.href = process.env.VUE_APP_BASEURL + res.data
            })
        },
        add() {
            this.$message({ message: '请在采购申请单模块，进行转单。（菜单：采购模块-采购申请单-转采购订单）', type: 'warning', duration: 10000 })

            //this.$router.push({ name: 'PurchaseOrderDetail' })
        },
        edit(row) {
            this.$router.push({ name: 'PurchaseOrderDetail', query: { id: row.id } })
        },
        view(row) {
            this.$router.push({ name: 'PurchaseOrderDetail', query: { id: row.id, mode: 'view' } })
        },
        deleter() {
            if (!this.$refs.table.chooseRow) {
                this.$message({ message: '请点击选择要删除的数据行', type: 'warning' })
                return
            }
            let that = this
            this.$confirm('此操作将删除本页选择数据, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
                .then(() => {
                    this.$kaung.delete(that.$refs.table.chooseRow.id).then(res => {
                        if (res.code === 200) {
                            that.$message({ message: res.content, type: res.type })
                            that.fetchs()
                        }
                    })
                })
        },

        auditor(rowId) {
            let rowIds = [];

            rowId = rowId || '';
            if (rowId == null || rowId == '') {
                if (this.$refs.table.chooseRow)
                    rowIds.push(this.$refs.table.chooseRow.id);
                if (this.$refs.table.selectIds && this.$refs.table.selectIds.length > 0)
                    rowIds.push(...this.$refs.table.selectIds);
            } else {
                rowIds.push(rowId);
            }
            rowIds = [...new Set(rowIds)];//去重
            if (rowIds.length == 0) {
                this.$kaung.message('请选择或者勾选其中一个要操作的数据');
                return;
            }

            // 使用 Vue 的 h 函数来创建虚拟 DOM 节点
            const selectOptions = [
                { value: '1', label: '审核通过，将自动创建到货单/回货单' },
                { value: '-1', label: '审核驳回' },
            ];
            let selectValue = selectOptions[0].value;
            this.$alert(h('div', {}, [
                h('select', {
                    style: 'width: 280px',
                    onChange: (event) => {
                        console.log('Selected:', event.target.value);
                        selectValue = event.target.value;
                    }
                }, selectOptions.map(option =>
                    h('option', { value: option.value }, option.label)
                )),
            ]), {
                title: '本次操作将作用于' + rowIds.length + '条数据，请确认',
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then((action) => {
                //console.log(action, selectValue); // 打印用户点击的是确认按钮还是取消按钮
                if (action == 'confirm') {
                    console.log(selectValue);
                    this.$kaung.fetch({
                        url: '/' + this.$options.name + '/Audit',
                        method: 'post',
                        params: {
                            ids: rowIds.join(','),
                            operate: selectValue,
                        }
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$kaung.success(res.content);
                            this.fetchs();
                        } else {
                            this.$kaung.error(res.content);
                        }
                    });
                }
            });
        },
    }
}
</script>

<style scoped>
.toolbar {
    margin-bottom: 20px
}

.table {
    margin-top: 10px
}
</style>
